/** @deprecated Use MUI's spacing system */
export const SPACES = {
  'x-x-large': '7rem',
  'x-large': '6rem',
  large: '4.8rem',
  'x-big': '4rem',
  big: '3.2rem',
  'x-medium': '2.5rem',
  medium: '2rem',
  normal: '1.5rem',
  small: '1rem',
  smaller: '0.85rem',
  'x-small': '0.5rem',
  'x-x-small': '0.3rem',
  'x-x-x-small': '0.2rem',
  tiny: '3px',
  'negative-nomral': '-1.5rem',
  negative: '-1rem',
  'negative-x-small': '-0.5rem',
  'no-space': '0',
  auto: 'auto'
};
/** @deprecated Use MUI's spacing system */
export const PADDING = {
  tooltip: '1rem 0.5rem',
  small: '0.25rem'
};
export const RADIUS = {
  large: '1rem',
  medium: '0.5rem',
  small: '0.3rem'
};

/** @deprecated Use our typography components */
export const SIZES = {
  tiny: '6px',
  'x-small': '0.8rem',
  smaller: '0.9rem',
  small: '1rem',
  normal: '1.1rem',
  medium: '1.2rem',
  'x-medium': '1.3rem',
  large: '1.4rem',
  'x-large': '1.6rem',
  'x-x-large': '1.8rem',
  'x-x-larger': '2.2rem',
  'x-x-x-large': '2.4rem',
  'x-x-x-larger': '2.9rem',
  'x-x-x-x-large': '3.4rem',
  huge: '4rem'
};

export const LINE_HEIGHT = {
  small: '1.4rem',
  normal: '1.4rem',
  medium: '1.8rem',
  large: '2rem',
  'x-large': '2.4rem'
};

export const ICON_SIZES = {
  'small-shape': '8px',
  'x-x-small': '0.5rem',
  'x-small': '1rem',
  smaller: '1.3rem',
  small: '1.5rem',
  normal: '1.75rem',
  medium: '2rem',
  'x-medium': '2.3rem',
  large: '2.5rem',
  'x-large': '3rem',
  'xx-large': '4rem',
  'xxx-large': '5rem'
};
